import { render, staticRenderFns } from "./FabricAvailabilityOverride.vue?vue&type=template&id=054b1447"
import script from "./FabricAvailabilityOverride.vue?vue&type=script&lang=js"
export * from "./FabricAvailabilityOverride.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports